(function ($) {
    // Removes any height set on each child so its auto height can be calculated.
    // The height of the tallest child is then applied to all children.
    function matchHeight(children) {
        let height = 0;
        // FLWEP2-4208 - Surface items mapped in the page are not rendering consistently
        children.css('height', 'auto');
        children.each(function () {
            height = Math.max(height, parseInt($(this).css('height')));
        });
        const heightValue = height + 'px';
        if (children.selector === '.surfaced-item-copy')
            children.css('height', heightValue);
        else
            children.css('min-height', heightValue);
    }

    // Define the plugin
    $.fn.matchHeight = function () {
        this.each(function () {
            const $self = $(this);
            const selectors = $self.attr('data-match-height-selectors') ? $self.attr('data-match-height-selectors').split(',') : [];
            const onResize = function () {
                selectors.forEach(selector => {
                    matchHeight($self.find(selector));
                });
            };

            $(window).off('resize', onResize);
            $(window).on('resize', onResize);
            $(window).on('load', onResize);
        });

        return this;
    };

    // Apply the plugin at dom-ready
    $(function () {
        $('.match-height').matchHeight();
    });
}(window.jQuery));